// extracted by mini-css-extract-plugin
export default {"container":"POIListView_container__qR-R2","selected":"POIListView_selected__os0nW","scroll":"POIListView_scroll__PFr-I"};